import React, { useEffect, useState } from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../../../utils/media-queries';
import RichText from '../../molecules/richtext';
import { useWindowSize } from '../../../hooks/useWindowSize';

const Collage = ({
  bigImageSrc,
  bigImageAlt,
  bigVideoSrc,
  smallImageSrc,
  smallImageAlt,
  smallVideoSrc,
  copy,
  type,
}) => {
  const size = useWindowSize();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (size.width < 1024) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [size]);

  if (isMobile)
    return (
      <StyledMobileCollage className="grid">
        {type === 'left' && (
          <>
            <figure
              className={`big ${
                type === 'left' ? 'image-left' : 'image-right'
              }`}
            >
              {bigImageSrc ? (
                <Img fluid={bigImageSrc} alt={bigImageAlt} />
              ) : (
                <video src={bigVideoSrc} autoPlay loop muted playsInline />
              )}
            </figure>
            <figure
              className={`small ${
                type === 'left' ? 'image-right' : 'image-left'
              }`}
            >
              {smallImageSrc ? (
                <Img fluid={smallImageSrc} alt={smallImageAlt} />
              ) : (
                <video src={smallVideoSrc} autoPlay loop muted playsInline />
              )}
            </figure>
          </>
        )}
        <div className={`image-copy ${type === 'left' ? 'right' : 'left'}`}>
          <div className="copy">
            <RichText blocks={copy} />
          </div>
        </div>
        {type === 'right' && (
          <>
            <figure
              className={`small ${
                type === 'left' ? 'image-right' : 'image-left'
              }`}
            >
              {smallImageSrc ? (
                <Img fluid={smallImageSrc} alt={smallImageAlt} />
              ) : (
                <video src={smallVideoSrc} autoPlay loop muted playsInline />
              )}
            </figure>
            <figure
              className={`big ${
                type === 'left' ? 'image-left' : 'image-right'
              }`}
            >
              {bigImageSrc ? (
                <Img fluid={bigImageSrc} alt={bigImageAlt} />
              ) : (
                <video src={bigVideoSrc} autoPlay loop muted playsInline />
              )}
            </figure>
          </>
        )}
      </StyledMobileCollage>
    );

  return (
    <StyledCollage className="grid">
      {type === 'left' && (
        <figure
          className={`big ${type === 'left' ? 'image-left' : 'image-right'}`}
        >
          {bigImageSrc ? (
            <Img fluid={bigImageSrc} alt={bigImageAlt} />
          ) : (
            <video src={bigVideoSrc} autoPlay loop muted playsInline />
          )}
        </figure>
      )}
      <div className={`image-copy ${type === 'left' ? 'right' : 'left'}`}>
        <figure
          className={`small ${type === 'left' ? 'image-right' : 'image-left'}`}
        >
          {smallImageSrc ? (
            <Img fluid={smallImageSrc} alt={smallImageAlt} />
          ) : (
            <video src={smallVideoSrc} autoPlay loop muted playsInline />
          )}
        </figure>
        <div className="copy">
          <RichText blocks={copy} />
        </div>
      </div>
      {type === 'right' && (
        <figure
          className={`big ${type === 'left' ? 'image-left' : 'image-right'}`}
        >
          {bigImageSrc ? (
            <Img fluid={bigImageSrc} alt={bigImageAlt} />
          ) : (
            <video src={bigVideoSrc} autoPlay loop muted playsInline />
          )}
        </figure>
      )}
    </StyledCollage>
  );
};

const StyledMobileCollage = styled.section`
  margin-bottom: var(--v-spacing-L);
  .image-copy {
    .copy {
      color: var(--blue);
    }
    grid-column: 1 / 20;
  }

  .big {
    height: 65vw;
  }

  .small.image-right {
    grid-column: 14 / 25;
    height: 40vw;
  }

  .small.image-left {
    margin-top: calc(var(--spacing-L) * 3);
    grid-column: 1 / 11;
  }

  .big.image-left {
    grid-column: 1 / 14;
  }

  .big.image-right {
    grid-column: 11 / 25;
  }
`;

const StyledCollage = styled.section`
  margin-bottom: var(--v-spacing-L);

  .copy {
    color: var(--blue);
    padding-top: var(--spacing-XXS);
    grid-column: 1 / 22;
  }

  .image-copy {
    grid-column: 1 / 22;
  }

  .small.image-left {
    margin-left: calc(var(--spacing-L) * 3.5);
  }

  .small.image-right {
    margin-right: calc(var(--spacing-L) * 3.5);
  }

  @media ${media.L} {
    position: relative;
    width: 100%;

    .big {
      height: 65vw;
      grid-column: 1 / 14;
    }

    .small {
      height: 30vw;
    }

    .image-left {
      grid-column: 1 / 14;
    }

    .image-right {
      grid-column: 12 / 25;
    }

    .image-copy {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .left {
      grid-column: 2 / 12;
      .copy {
        text-align: right;
      }
    }

    .right {
      grid-column: 14 / 24;
    }
  }

  @media ${media.XL} {
    position: relative;
    width: 100%;

    .left {
      grid-column: 2 / 12;
      .copy {
        text-align: right;
      }
    }

    .right {
      grid-column: 14 / 22;
    }
  }
`;

Collage.propTypes = {
  bigImageSrc: PropTypes.object,
  bigImageAlt: PropTypes.string,
  smallImageSrc: PropTypes.object,
  smallImageAlt: PropTypes.string,
  copy: PropTypes.array,
  type: PropTypes.string,
  bigVideoSrc: PropTypes.string,
  smallVideoSrc: PropTypes.string,
};

export default Collage;
